import { render, staticRenderFns } from "./item-template.vue?vue&type=template&id=153dcab4&scoped=true&"
import script from "./item-template.vue?vue&type=script&lang=js&"
export * from "./item-template.vue?vue&type=script&lang=js&"
import style0 from "./item-template.vue?vue&type=style&index=0&id=153dcab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153dcab4",
  null
  
)

export default component.exports